<div (click)="download()" class="h-full w-full cursor-pointer">
  <img
    *ngIf="isImage() && attachment.imgUrl"
    [src]="attachment.imgUrl"
    class="h-full w-full object-fit" />
  <div
    *ngIf="!isImage() || !attachment.imgUrl"
    class="h-full w-full flex justify-center items-center p-4">
    <div class="p-2 shadow bg-foreground rounded-full text-lg select-none">
      {{ attachment.type }}
    </div>
  </div>

  <div class="vex-mail-attachment-overlay">
    <p class="truncate">{{ attachment.label }}</p>
  </div>
</div>
